export default __webpack_public_path__ + "static/media/reference.d1708813.png";